export const PARTNER_REVEAL_LINES = [
    'Find the right AI Video Director for your needs.',
    'Explore their reels, submit your details, and receive',
    'personalized guidance from our team.',
];

export const PARTNER_REVEAL_FULL_TEXT = PARTNER_REVEAL_LINES.join(' ');
